import React from 'react';
import { Input } from 'reactstrap';
import './index.scss';

const VersionDropdown = ({ options, handleVal, val = '', loader, inputDisabled }) => {
    // console.log('vallll',val)

    const handleOnChange = (value) => {
        handleVal(value);
    };

    return (
        <div className={`version-dropdown${!loader ? " disable" : ""}`}>
            <Input disabled={inputDisabled} type="select" name="select" onChange={($event) => { handleOnChange($event.target.value); }} className="form-select">
                {<option value='0'>
                    {'Original Version'}</option>}
                {options && options.map((item, index) => {
                    if (item.version) {
                        return (<option key={index} selected={item.version == val} value={item.version}>
                            {item.version ? 'Version ' + item.version : 'Original'}</option>);

                    }

                })}
            </Input>
        </div>
    )
}

export default VersionDropdown;